import { Box, Typography } from '@mui/material';
import '../../styles/scss/Dashboard.scss';

export default function Dashboard() {
  const stats = [
    { 
      type: 'orders',
      title: 'Total Washes', 
      value: '1,847', 
      change: '+18.3%',
      icon: 'local_car_wash',
    },
    { 
      type: 'products',
      title: 'Active Services', 
      value: '12', 
      change: '+2',
      icon: 'miscellaneous_services',
    },
    { 
      type: 'revenue',
      title: 'Total Revenue', 
      value: '₹8,45,678', 
      change: '+22.7%',
      icon: 'trending_up',
    },
    { 
      type: 'customers',
      title: 'Total Customers', 
      value: '3,421', 
      change: '+14.8%',
      icon: 'group',
    },
  ];

  const revenueData = [
    { day: 'Mon', date: 'May 18', revenue: '₹28,450', washes: 42, percentage: 85, color: '#b71c1c' },
    { day: 'Tue', date: 'May 19', revenue: '₹32,100', washes: 48, percentage: 96, color: '#c62828' },
    { day: 'Wed', date: 'May 20', revenue: '₹26,800', washes: 38, percentage: 80, color: '#d32f2f' },
    { day: 'Thu', date: 'Today', revenue: '₹18,200', washes: 26, percentage: 54, color: '#e53935' },
  ];

  const recentWashes = [
    { id: '#W-4523', vehicle: 'Tata Nexon (KA-01-AB-1234)', customer: 'Rahul Sharma', service: 'Premium Exterior Wash', status: 'Completed' },
    { id: '#W-4522', vehicle: 'Hyundai i20 (KA-03-CD-5678)', customer: 'Priya Patel', service: 'Interior Deep Cleaning', status: 'In Progress' },
    { id: '#W-4521', vehicle: 'Maruti Swift (KA-05-EF-9012)', customer: 'Amit Kumar', service: 'Full Detailing Package', status: 'Completed' },
    { id: '#W-4520', vehicle: 'Honda City (KA-02-GH-3456)', customer: 'Sneha Gupta', service: 'Exterior Wash + Wax', status: 'Pending' },
  ];

  const topServices = [
    { name: 'Premium Exterior Wash', booked: 312, revenue: '₹1,87,200' },
    { name: 'Interior Deep Cleaning', booked: 245, revenue: '₹2,20,500' },
    { name: 'Full Detailing Package', booked: 178, revenue: '₹3,56,000' },
    { name: 'Exterior Wash + Wax', booked: 156, revenue: '₹1,09,200' },
  ];

  const washStatuses = [
    { status: 'Pending', count: 23, color: '#f59e0b' },
    { status: 'In Progress', count: 38, color: '#e53935' },
    { status: 'Completed', count: 312, color: '#22c55e' },
    { status: 'Cancelled', count: 12, color: '#ef4444' },
  ];

  return (
    <Box className="dashboard-page">
      <Box className="dashboard-header">
        <Typography variant="h4" className="dashboard-title">
          Dashboard Overview
        </Typography>
        <Typography variant="body2" className="dashboard-subtitle">
          Welcome back! Here's what's happening with your car wash today.
        </Typography>
      </Box>

      <Box className="stats-grid">
        {stats.map((stat) => (
          <Box key={stat.type} className={`stat-card ${stat.type}`}>
            <Box className="stat-content">
              <Box className="stat-info">
                <p>{stat.title}</p>
                <p>{stat.value}</p>
                <p>{stat.change}</p>
              </Box>
              <Box className={`stat-icon ${stat.type}`}>
                <span className="material-symbols-outlined">{stat.icon}</span>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>

      <Box className="dashboard-sections">
        <Box className="section recent-orders">
          <Box className="section-header">
            <h3>Recent Washes</h3>
            <a href="#" className="view-all">View All</a>
          </Box>
          <Box className="orders-list">
            {recentWashes.map((wash) => (
              <Box key={wash.id} className="order-item">
                <Box className="order-info">
                  <p className="order-id">{wash.id}</p>
                  <p className="order-customer">{wash.customer}</p>
                  <p className="order-items">{wash.vehicle} — {wash.service}</p>
                </Box>
                <Box className="order-meta">
                  <span className={`order-status ${wash.status.toLowerCase().replace(' ', '-')}`}>{wash.status}</span>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>

        <Box className="section recent-reviews">
          <Box className="section-header">
            <h3>Revenue by Day</h3>
            <span className="period">This Week</span>
          </Box>
          <Box className="status-bars">
            {revenueData.map((item, idx) => (
              <Box key={idx} className="status-item" style={{ marginBottom: 16 }}>
                <Box className="status-label" style={{ marginBottom: 2 }}>
                  <span style={{ fontWeight: 600, color: 'var(--on-surface)' }}>{item.day}</span>
                  <span style={{ fontSize: 11, color: 'var(--on-surface-variant)' }}>{item.washes} washes</span>
                </Box>
                <Box className="status-label" style={{ marginBottom: 6 }}>
                  <span style={{ fontSize: 14, fontWeight: 700 }}>{item.revenue}</span>
                  <span style={{ fontSize: 11, color: 'var(--on-surface-variant)' }}>{item.date}</span>
                </Box>
                <Box className="status-bar">
                  <Box
                    className="status-fill"
                    style={{ width: `${item.percentage}%`, background: item.color }}
                  />
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>

      <Box className="dashboard-sections secondary">
        <Box className="section top-products">
          <Box className="section-header">
            <h3>Top Services</h3>
            <span className="period">This Month</span>
          </Box>
          <Box className="products-list">
            {topServices.map((service, idx) => (
              <Box key={idx} className="product-item">
                <Box className="product-rank">{idx + 1}</Box>
                <Box className="product-details">
                  <p className="product-name">{service.name}</p>
                  <p className="product-sold">{service.booked} bookings</p>
                </Box>
                <p className="product-revenue">{service.revenue}</p>
              </Box>
            ))}
          </Box>
        </Box>

        <Box className="section order-status">
          <Box className="section-header">
            <h3>Wash Status</h3>
          </Box>
          <Box className="status-bars">
            {washStatuses.map((item, idx) => (
              <Box key={idx} className="status-item">
                <Box className="status-label">
                  <span>{item.status}</span>
                  <span className="status-count">{item.count}</span>
                </Box>
                <Box className="status-bar">
                  <Box 
                    className="status-fill" 
                    style={{ 
                      width: `${(item.count / 350) * 100}%`,
                      background: item.color 
                    }} 
                  />
                </Box>
              </Box>
            ))}
          </Box>
        </Box>

        <Box className="section quick-stats">
          <Box className="section-header">
            <h3>Quick Stats</h3>
          </Box>
          <Box className="quick-stats-grid">
            <Box className="quick-stat">
              <span className="material-symbols-outlined">local_car_wash</span>
              <p className="stat-value">12</p>
              <p className="stat-label">Service Types</p>
            </Box>
            <Box className="quick-stat">
              <span className="material-symbols-outlined">star</span>
              <p className="stat-value">4.7</p>
              <p className="stat-label">Avg Rating</p>
            </Box>
            <Box className="quick-stat">
              <span className="material-symbols-outlined">reviews</span>
              <p className="stat-value">847</p>
              <p className="stat-label">Reviews</p>
            </Box>
            <Box className="quick-stat">
              <span className="material-symbols-outlined">schedule</span>
              <p className="stat-value">94%</p>
              <p className="stat-label">On-time Completion</p>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
